import { ItemAttributeBase } from './base/item-attribute-base';

export class ItemAttribute extends ItemAttributeBase { }